"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCompactProviderCardContainer = exports.WarningMessageWrapper = exports.NegativeMarginTopSpacingMediumWrapper = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
const breakpoints_1 = require("../../lib/constants/breakpoints");
exports.NegativeMarginTopSpacingMediumWrapper = styled_1.default.div `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.WarningMessageWrapper = styled_1.default.div `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  top: calc(${breakpoints_1.HEADER_HEIGHT});
  position: sticky;
  z-index: 10;
  max-width: 100%;
`;
exports.StyledCompactProviderCardContainer = styled_1.default.div `
  margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} -${(0, ui_theme_1.fromTheme)('spacing_large')} 0 -${(0, ui_theme_1.fromTheme)('spacing_large')};
  border-bottom: 4px solid ${(0, ui_theme_1.fromTheme)('color_background_secondary')};
`;
//# sourceMappingURL=styles.js.map